import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0f1a2e] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Colonne 1 - Identité */}
          <div>
            <h3 className="text-xl font-bold mb-4">SOCIÉTÉ VAUCLUSIENNE D'AUTOMOBILES</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              Votre partenaire automobile à Carpentras. Vente de véhicules, solutions de financement 
              et assurance à titre accessoire.
            </p>
          </div>

          {/* Colonne 2 - Navigation */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-wider mb-4">NAVIGATION</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/societe" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  La Société
                </Link>
              </li>
              <li>
                <Link to="/financement" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Financement
                </Link>
              </li>
              <li>
                <Link to="/assurance" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Assurance
                </Link>
              </li>
              <li>
                <Link to="/partenaires" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Partenaires
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Conformité */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-wider mb-4">CONFORMITÉ</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                  Mentions légales
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.orias.fr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer"
                >
                  ORIAS
                </a>
              </li>
            </ul>
          </div>

          {/* Colonne 4 - Coordonnées */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-wider mb-4">ADRESSE</h4>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-map-pin-line text-lg"></i>
              </div>
              <address className="text-sm text-white not-italic leading-relaxed">
                530 ROUTE D'AVIGNON<br />
                84200 CARPENTRAS<br />
                France
              </address>
            </div>
          </div>
        </div>
      </div>

      {/* Barre inférieure */}
      <div className="bg-[#0a1220] py-6">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400">
            <p>© 2025 SOCIÉTÉ VAUCLUSIENNE D'AUTOMOBILES</p>
            <p className="font-mono">ORIAS 07008531 | SIREN 311 296 628</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
